
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/profile-main/js/profile-main';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/widgets/profile-menu/js/profile-menu';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/trusted-proxy/js/trusted-proxy';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/usage-reports/js/usage-reports';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/manage-alerts/js/manage-alerts';
   //I've found a weird interaction between manage-alerts and this one, 'select all' is shared between, interaction must be moved to basic/inputs
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-theme/widgets/device-pairing/js/device-pairing';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/admin-manage-alerts/js/admin-manage-alerts';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/pairing-management/js/pairing-management';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/holdings/js/holdings';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/widgets/download-marc-form-v2/js/marc';
  
const main = (UX) => {
    const $profileMain = Array.prototype.slice.call(document.getElementsByClassName('institutionList')),
        $dropblockUl = Array.prototype.slice.call(document.getElementsByClassName('profile-menu')),
        $trustedPoxy = Array.prototype.slice.call(document.getElementsByClassName('trusted-proxy-form')),
        $reports = document.getElementById('institutionUsageReport'),
        $alerts = Array.prototype.slice.call(document.querySelectorAll('.alerts, #institutionUsageReport')),
        $devicePairing = Array.prototype.slice.call(document.getElementsByClassName('device-pairing__devices')),
        $pairingManagment = document.getElementById('pairingManagmentWidgetId'),
        $holdings = document.getElementById('holdingsForm')

try {
        if ($profileMain.length ) {
            UX.profileMain.init($profileMain);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($dropblockUl.length ) {
            UX.dropblockUl.init($dropblockUl);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($trustedPoxy.length ) {
            UX.trustedPoxy.init($trustedPoxy);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($reports ) {
            UX.reports.init($reports);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($alerts.length ) {
            UX.alerts.init($alerts);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($devicePairing.length ) {
            UX.devicePairing.init($devicePairing);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($pairingManagment ) {
            UX.pairingManagment.init($pairingManagment);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($holdings ) {
            UX.holdings.init($holdings);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        